import { z } from 'zod';
import { phoneSchema } from '../phone/phone.js';
import { otpCodeSchema } from '../phone/verification.js';
/**
 * The verification step of the Debts web app (debts.md section 21). The Debts
 * API asks Customers for the code as the system DEBTS with the signed-in
 * employee, so the binding of customers.md section 10.4 holds. The purpose
 * and the target customer are decided by the API from the debtor, never by
 * the browser:
 *
 * - no `debtorId`: إضافة عميل, purpose CREATE;
 * - `debtorId`: تعديل العميل, CHANGE_PHONE for a debtor that has a Customers
 *   person, otherwise CREATE (its first registration);
 * - `reverify`: إعادة التحقق, the purpose and target of the failed outbox row
 *   for the stored phone (`phone` is then ignored and may be omitted).
 */
export const debtsRequestPhoneVerificationSchema = z
    .object({
    phone: phoneSchema.optional(),
    debtorId: z.string().trim().min(1).max(64).optional(),
    reverify: z.boolean().default(false),
    language: z.enum(['ar', 'en']).default('ar'),
})
    .strict()
    .superRefine((value, ctx) => {
    if (value.reverify && !value.debtorId) {
        ctx.addIssue({ code: 'custom', path: ['debtorId'], message: 'debtorId is required' });
    }
    if (!value.reverify && value.phone === undefined) {
        ctx.addIssue({ code: 'custom', path: ['phone'], message: 'PHONE_REQUIRED' });
    }
});
/** POST /phone-verifications/{id}/verify (the employee comes from the session). */
export const debtsVerifyPhoneVerificationSchema = z.object({ code: otpCodeSchema }).strict();
//# sourceMappingURL=phone-verification.js.map